import {BaseActionButton} from './BaseActionButton';

class Undo extends BaseActionButton {
  icon = 'undo';
  tooltip = 'Undo';

  disabled = () => {
    return !this.rackEditorStore.rackStore.changes.canUndo;
  };

  onClick = () => {
    const {rackStore, selection} = this.rackEditorStore;
    this.hidePopups(true, true);
    selection.select(...rackStore.undo());
  };
}

export {Undo};
